<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        เพิ่มข้อมูลโรงกำจัด
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        elevation="0"
        large
        dark
        class="mr-4 px-10"
        @click="back()"
      >
        <div><v-icon left>mdi-minus</v-icon>กลับ</div>
      </v-btn>
      <v-btn
        color="primary"
        elevation="0"
        large
        dark
        class="mr-4 px-10"
        @click="save()"
      >
        <div><v-icon left>mdi-plus</v-icon>บันทึกข้อมูล</div>
      </v-btn>
    </v-layout>
    <v-divider class="mt-2 mb-8"></v-divider>
    <div class="d-flex flex-column">
      <div class="d-flex justify-start">
        <div style="margin-left: 50px; width: 200px">
          <div class="mt-3">
            <h4>ชื่อโรงกำจัด :</h4>
          </div>

          <div class="mt-9" style="margin-bottom: 75px !important">
            <h4>ที่อยู่ :</h4>
          </div>
          <div>
            <h4>อีเมล์(โรงกำจัด) :</h4>
          </div>
        </div>
        <div style="width: 300px">
          <div>
            <v-text-field
              solo
              label="ชื่อโรงกำจัด"
              v-model="c_name"
              :rules="nameRules"
            ></v-text-field>
          </div>

          <div class="mt-n5">
            <v-textarea
              solo
              label="ที่อยู่"
              rows="3"
              no-resize
              v-model="c_address"
              :rules="nameRules"
            ></v-textarea>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="อีเมล์"
              v-model="c_email"
              :rules="emailRules"
            ></v-text-field>
          </div>
        </div>
        <div style="margin-left: 50px; width: 200px">
          <div class="mt-3">
            <h4>ชื่อพนักงาน :</h4>
          </div>
          <div class="mt-15">
            <h4>เบอร์สำนักงาน :</h4>
          </div>
          <div class="mt-15">
            <h4>เบอร์มือถือ :</h4>
          </div>
        </div>
        <div style="width: 300px">
          <div class="mb-3">
            <v-text-field
              solo
              label="ชื่อพนักงาน"
              v-model="c_preson"
              :rules="nameRules"
            ></v-text-field>
          </div>
          <div class="mb-3">
            <v-text-field
              solo
              label="เบอร์สำนักงาน"
              v-model="c_tel"
              :rules="nameRules"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="เบอร์มือถือ"
              v-model="c_mobile"
              :rules="nameRules"
            ></v-text-field>
          </div>
        </div>
      </div>

      <v-divider class="my-2"></v-divider>
    </div>
  </v-form>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      c_name: "",
      c_address: "",
      c_email: "",
      c_tel: "",
      c_mobile: "",
      c_preson: "",
      nameRules: [
        (v) => !!v || "กรุณากรอกเบอร์",
        (v) => (v && v.length <= 10) || "กรุณากรอกเบอร์ให้ถูกต้อง",
      ],

      emailRules: [
        (v) => !!v || "กรุณากรอก E-mail",
        (v) => /.+@.+\..+/.test(v) || "กรุณากรอก E-mail ให้ถูกต้อง",
      ],
    };
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        let data_i = {
          DESTROYER_NAME: this.c_name,
          DESTROYER_ADDRESS: this.c_address,
          DESTROYER_PHONE: this.c_tel,
          DESTROYER_OFFCIA_PHONE: this.c_mobile,
          DESTROYER_EMAIL: this.c_email,
          DESTROYER_OFFCIA: this.c_preson,
        };
        console.log(data_i);
        this.$token_api
          .post("/insert-destroy", data_i)
          .then((res) => {
            this.$swal({
              title: "บันทึกเรียบร้อย",
              timer: 2000,
              icon: "success",
            });
            this.$router.push({ path: "/settings/company-data-destroy" });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.$swal({
          title: "ข้อมูลไม่ครบ",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          timer: 2000,
          icon: "warning",
        });
      }
    },
    back(){
       this.$router.push({ path: "/settings/company-data-destroy" });
    }
  },
};
</script>